import { css } from '@emotion/css';
import { type JSX } from 'react';
import { useTranslation } from 'react-i18next';

const photoButton = css`
  user-select: none;
  width: 70px;
  height: 70px;
  top: 50%;
  left: 50%;
  margin-top: -35px;
  margin-left: -35px;
  position: absolute;

  &:active [data-comp='circle'] {
    opacity: 0.5;
  }

  &:active [data-comp='ring'] {
    opacity: 0.8;
  }
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
`;

const circle = css`
  position: absolute;
  top: 10%;
  left: 10%;
  bottom: 10%;
  right: 10%;
  border-radius: 100%;
  background-color: #ffffff;
  opacity: 1;
  outline: 0 !important;
`;

const ring = css`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  border-radius: 100%;
  border: 0.3em solid #ffffff;
  opacity: 0.8;
  outline: 0 !important;
`;

interface CameraButtonShutterProps {
  onClick: () => void;
}

export function CameraButtonShutter({
  onClick,
}: CameraButtonShutterProps): JSX.Element {
  const { t } = useTranslation();
  return (
    // eslint-disable-next-line jsx-a11y/control-has-associated-label
    <button
      className={photoButton}
      onClick={onClick}
      aria-label={t('ariaLabels.shutterBT')}
    >
      <div data-comp="circle" className={circle} />
      <div data-comp="ring" className={ring} />
    </button>
  );
}
